<div class="hidden flex-col gap-8 mt-6 md:flex">
  @for (section of contentSections; track section.kind) {
    @if (section.items.length !== 0) {
      <div>
        <div class="mt-3">
          <app-slider
            [items]="section.items"
            [itemTemplate]="itemTemplate"
            [headerTemplate]="viewAllTemplate"
            [titleTemplate]="titleTemplate"
            [alwaysDisplay]="true"
          />
        </div>

        <ng-template #titleTemplate>
          <span>
            <h2 class="inline font-bold text-sm pr-2">{{ section.title }}</h2>
            <p class="inline text-xs text-muted">({{ section.items.length }})</p>
          </span>
        </ng-template>

        <ng-template #viewAllTemplate>
          <button
            type="button"
            class="text-grey-900 text-sm px-6 py-2 rounded-sm border border-grey-400 cursor-pointer"
            (click)="openViewAllModal(section.items, section.kind)"
          >
            {{ 'placements.viewAll' | transloco }}
          </button>
        </ng-template>

        <ng-template #itemTemplate [templateType]="itemTemplateType" let-item>
          <div class="flex-none max-w-72">
            <app-placement-content-card [item]="item"></app-placement-content-card>
          </div>
        </ng-template>
      </div>
    }
  }
</div>

<div class="block md:hidden">
  <div class="flex flex-col gap-4 pb-8">
    @for (item of filteredPlacements; track item.title) {
      <app-placement-content-card [item]="item"></app-placement-content-card>
    }
  </div>
  <div class="fixed bottom-0 w-full bg-grey-bg border-t border-grey-300 -ml-4">
    <div class="p-4">
      <p-selectbutton
        [options]="selectButtonOptions"
        [ngModel]="selectedType$.value"
        (ngModelChange)="selectedType$.next($event)"
        (onChange)="filterPlacements($event)"
        optionLabel="label"
        optionValue="value"
        optionDisabled="empty"
        size="small"
        fluid
        unselectable
      ></p-selectbutton>
    </div>
  </div>
</div>
